import { Send, Star } from "lucide-react";
import { useLeadModal } from "@/context/LeadModalContext";
import Reveal from "@/components/landing/Reveal";

export default function FinalCTA() {
  const { openModal } = useLeadModal();

  return (
    <section
      data-testid="final-cta-section"
      className="relative py-20 sm:py-28"
    >
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <Reveal>
        <div
          className="relative overflow-hidden rounded-[32px] border border-yellow-400/30 p-8 text-center sm:p-14 lg:p-20"
          style={{
            background:
              "radial-gradient(ellipse at top, rgba(255,215,0,0.12), transparent 60%), radial-gradient(ellipse at bottom, rgba(0,240,255,0.08), transparent 60%), #080808",
            boxShadow:
              "0 0 60px rgba(255,215,0,0.15), inset 0 0 80px rgba(0,0,0,0.5)",
          }}
        >
          {/* Decorative grid */}
          <div className="pointer-events-none absolute inset-0 bg-grid-pattern opacity-30" />

          {/* Decorative top-right candle */}
          <div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-yellow-400/20 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-10 -left-10 h-40 w-40 rounded-full bg-cyan-400/15 blur-3xl" />

          <div className="relative">
            {/* Rating */}
            <div
              data-testid="final-rating"
              className="mb-5 inline-flex items-center gap-1.5 rounded-full border border-yellow-400/30 bg-black/40 px-4 py-1.5 backdrop-blur-sm"
            >
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="h-3.5 w-3.5 fill-yellow-400 text-yellow-400"
                />
              ))}
              <span className="ml-1 font-heading text-[11px] font-bold uppercase tracking-wider text-yellow-300">
                Oltre 15.000 persone in community
              </span>
            </div>

            <h2
              data-testid="final-cta-title"
              className="mx-auto max-w-3xl font-heading text-3xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-6xl"
            >
              Pronto ad attivare{" "}
              <span className="text-gradient-gold">Aurum AI</span>?
            </h2>

            <p
              data-testid="final-cta-subtitle"
              className="mx-auto mt-5 max-w-2xl font-body text-base text-gray-300 sm:text-lg"
            >
              Entra nel canale Telegram gratuito. Scopri come funziona Aurum AI e come iniziare il collegamento guidato in meno di 10 minuti.
            </p>

            {/* CTA */}
            <div className="mt-9 flex flex-col items-center gap-4">
              <button
                type="button"
                onClick={openModal}
                data-testid="final-telegram-cta"
                className="group inline-flex w-full max-w-md items-center justify-center gap-3 rounded-full bg-gradient-to-r from-yellow-300 via-yellow-400 to-yellow-600 px-8 py-5 font-heading text-base font-black uppercase tracking-wider text-black shadow-[0_0_40px_rgba(255,215,0,0.5)] transition-all duration-300 hover:scale-[1.03] hover:shadow-[0_0_60px_rgba(255,215,0,0.75)] sm:text-lg"
              >
                <Send className="h-5 w-5 transition-transform group-hover:translate-x-1" />
                Scopri di più
              </button>

              <div
                data-testid="final-disclaimer"
                className="font-body text-xs text-gray-500"
              >
                Accesso 100% gratuito · Nessuna carta richiesta
              </div>
            </div>
          </div>
        </div>
        </Reveal>
      </div>
    </section>
  );
}
